var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimulationsEmptyState = function SvgSimulationsEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 262,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.004 238.283c54.868 0 99.347-44.479 99.347-99.346 0-54.867-44.479-99.346-99.347-99.346-54.867 0-99.346 44.479-99.346 99.346 0 54.867 44.479 99.346 99.346 99.346Z",
    fill: "url(#simulations-empty-state_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m183.627 206.764-17.341-67.56a44.59 44.59 0 0 0 9.834-28.15 45.039 45.039 0 0 0-76.888-31.848 45.04 45.04 0 0 0-13.192 31.848 44.59 44.59 0 0 0 10.059 28.3l-17.566 67.41a7.507 7.507 0 0 0 11.11 8.332l40.011-23.496 42.638 23.571a6.832 6.832 0 0 0 3.828.976 7.513 7.513 0 0 0 6.101-2.813 7.506 7.506 0 0 0 1.406-6.57ZM131.08 81.027a30.026 30.026 0 1 1 0 60.053 30.026 30.026 0 0 1 0-60.053Z",
    fill: "url(#simulations-empty-state_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.893 89.81a12.498 12.498 0 0 1-12.52 12.514h-41.624a16.896 16.896 0 0 1-2.695-.223 15.726 15.726 0 0 1-13.021-16.515 15.728 15.728 0 0 1 15.042-14.698 22.157 22.157 0 0 1 42.096 6.409h.189a12.506 12.506 0 0 1 8.861 3.657 12.515 12.515 0 0 1 3.672 8.856Z",
    fill: "url(#simulations-empty-state_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.336 64.992a9.434 9.434 0 0 0 9.434 9.434h31.32a11.84 11.84 0 0 0 .5-23.666 16.684 16.684 0 0 0-31.672 4.819h-.141a9.434 9.434 0 0 0-9.441 9.413Z",
    fill: "url(#simulations-empty-state_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 185.611a12.451 12.451 0 0 0 10.822 12.351c.545.076 1.094.114 1.644.115H77.91a16.787 16.787 0 0 0 2.695-.222 15.67 15.67 0 0 0 13.061-16.471 15.664 15.664 0 0 0-15.083-14.641 22.07 22.07 0 0 0-23.36-12.572 22.066 22.066 0 0 0-18.56 18.953h-.196a12.462 12.462 0 0 0-11.523 7.71 12.466 12.466 0 0 0-.943 4.777Z",
    fill: "url(#simulations-empty-state_svg__e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210.766 117.088c-.315-1.235.825-2.347 2.052-2.003l6.433 1.808c1.226.345 1.62 1.888.708 2.778l-4.782 4.667a1.655 1.655 0 0 1-2.76-.776l-1.651-6.474ZM45.178 117.088a1.656 1.656 0 0 1 2.052-2.003l6.433 1.808a1.655 1.655 0 0 1 .708 2.778l-4.782 4.667a1.655 1.655 0 0 1-2.76-.776l-1.65-6.474ZM100.49 31.999c.489-2.027 3.372-2.027 3.862 0l1.129 4.68c.175.724.741 1.29 1.465 1.464l4.68 1.13c2.027.49 2.027 3.372 0 3.862l-4.68 1.13c-.724.174-1.29.74-1.465 1.464l-1.129 4.68c-.49 2.027-3.373 2.027-3.862 0l-1.13-4.68a1.986 1.986 0 0 0-1.465-1.465l-4.68-1.13c-2.026-.489-2.026-3.372 0-3.86l4.68-1.13a1.986 1.986 0 0 0 1.465-1.465l1.13-4.68Z",
    fill: "#A9E0D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.167 220.411a3.777 3.777 0 1 1-7.554 0 3.777 3.777 0 0 1 7.554 0Z",
    stroke: "#A9E0D4",
    strokeWidth: 2.483
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.447 188.985c.489-2.027 3.372-2.027 3.862 0l1.129 4.68c.175.724.741 1.29 1.465 1.465l4.68 1.129c2.027.49 2.027 3.373 0 3.862l-4.68 1.13c-.724.175-1.29.74-1.465 1.465l-1.129 4.68c-.49 2.026-3.373 2.026-3.862 0l-1.13-4.68a1.985 1.985 0 0 0-1.465-1.465l-4.68-1.13c-2.026-.489-2.026-3.372 0-3.862l4.68-1.129a1.987 1.987 0 0 0 1.465-1.465l1.13-4.68Z",
    fill: "#A9E0D4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 216.397,
    cy: 163.065,
    r: 3.776,
    stroke: "#5DC0AD",
    strokeOpacity: 0.4,
    strokeWidth: 2.483
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "simulations-empty-state_svg__a",
    x1: 131.239,
    y1: 7.241,
    x2: 133.274,
    y2: 356.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simulations-empty-state_svg__b",
    x1: 277.5,
    y1: -138.5,
    x2: -25,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#8FF5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42796E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simulations-empty-state_svg__c",
    x1: 221.63,
    y1: 121.439,
    x2: 186.863,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simulations-empty-state_svg__d",
    x1: 74.899,
    y1: 88.799,
    x2: 48.755,
    y2: 41.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simulations-empty-state_svg__e",
    x1: 80.472,
    y1: 217.121,
    x2: 45.854,
    y2: 153.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })))));
};
export default SvgSimulationsEmptyState;